import React, { useEffect, useRef } from 'react';

import type { PreloadedEntryPoint } from 'react-relay';

import { WaitForEntryPointLoad } from '../wait-for-entry-point-load';

export type FocusOnLoadProps = {
	// eslint-disable-next-line @typescript-eslint/no-explicit-any
	entryPointReference: PreloadedEntryPoint<any>;
	onLoad: (container: HTMLElement) => void;
};

function FocusOnLoadInner({ onLoad }: Pick<FocusOnLoadProps, 'onLoad'>): React.JSX.Element {
	const anchorRef = useRef<HTMLSpanElement>(null);

	useEffect(() => {
		// `Popup` does not expose a ref to the element wrapping its content, so
		// it is resolved through this anchor, which renders as a sibling of the
		// loaded experience inside that element.
		const container = anchorRef.current?.parentElement;

		if (container) {
			onLoad(container);
		}
	}, [onLoad]);

	return <span ref={anchorRef} hidden />;
}

export function FocusOnLoad({ entryPointReference, onLoad }: FocusOnLoadProps): React.JSX.Element {
	return (
		<WaitForEntryPointLoad entryPointReference={entryPointReference}>
			<FocusOnLoadInner onLoad={onLoad} />
		</WaitForEntryPointLoad>
	);
}
